module.exports = __webpack_public_path__ + "static/media/avatar.f9df625f.png";